import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { PenBox } from "lucide-react";
import { getDoc, doc } from "firebase/firestore";
import { auth, db } from "../register/firebase";

const BlogEditorButton = () => {
  const [isWriter, setIsWriter] = useState(false);

  useEffect(() => {
    const checkWriterAccess = async () => {
      const user = auth.currentUser;
      if (!user) {
        console.log("No user is signed in.");
        return;
      }

      try {
        const docRef = doc(db, "bolg_writers", "Xr5rMLakwXHA1QylSikl");
        const docSnap = await getDoc(docRef);

        console.log("Current User UID:", user.uid);

        if (docSnap.exists()) {
          const writers = docSnap.data().writers || [];
          console.log("Writer List from DB:", writers);

          if (writers.includes(user.uid)) {
            console.log("✅ User has writer access.");
            setIsWriter(true);
          } else {
            console.log("❌ User does NOT have writer access.");
          }
        } else {
          console.log("Document does not exist.");
        }
      } catch (error) {
        console.error("Error checking writer access:", error);
      }
    };

    checkWriterAccess();
  }, []);

  if (!isWriter) return null;

  return (
    <Link
      to="/blog-editor"
      className="inline-flex items-center gap-2 bg-gray-600 text-white font-medium py-2.5 px-5 rounded-xl shadow hover:bg-blue-700 transition duration-300 focus:outline-none focus:ring-2 focus:ring-blue-400"
      title="Write a new blog post"
    >
      <PenBox className="w-5 h-5" />
      <span className="hidden sm:inline">Write Blog</span>
    </Link>
  );
};

export default BlogEditorButton;
